import { sameAccount } from '../../../utils/accountIds';

// One lookup per account is the only way to learn its parent, so each entity type's burst is budgeted, and a grid
// carrying two types asks up to twice this: real sub-account lists run to a median of 4 and a ninth decile of 31,
// while the largest reaches 439 — past the budget the write reports instead.
export const MAX_ACCOUNTS_ASKED = 32;

// The accounts a grid must ask about: the ones its rows name that the offered definitions were not fetched for.
// Deduplicated case-insensitively but returned as the row spelled them, since that is the id the api authorizes.
export const foreignRowAccountIds = <T>(
  rows: T[],
  rowAccountId: (row: T) => string | undefined,
  definitionsAccountId: string | null
): string[] => {
  // No definitions were fetched, so no custom-field column exists for an answer to gate.
  if (!definitionsAccountId) return [];

  const seen = new Set<string>();
  const asked: string[] = [];
  for (const row of rows) {
    if (asked.length >= MAX_ACCOUNTS_ASKED) break;
    const accountId = rowAccountId(row);
    if (!accountId || sameAccount(accountId, definitionsAccountId) || seen.has(accountId.toLowerCase())) continue;
    seen.add(accountId.toLowerCase());
    asked.push(accountId);
  }
  return asked;
};
